export const FLAG_EMAIL_QUOTA = 'advertiser_email_quota'
export const FLAG_GA_ORDER_COLLECTOR = 'advertiser_ga_order_collector'
export const FLAG_CHANNELS = 'advertiser_app_channels'
export const FLAG_CONTENT_DETAIL_MODAL = 'advertiser_app_content_detail_modal'
export const FLAG_SEGMENTS = 'advertiser_app_segments'
export const FLAG_PARTICIPANT_PAYMENT_SPLIT = 'advertiser_app_participant_payment_split'
